import { computed } from '@ember/object';

import { buildValidations as originalBuildValidations } from 'ember-cp-validations';

import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export function buildValidations(validations, options) {
  return originalBuildValidations(validations, {
    recordType: computed('model', function () {
      return getRecordType(this.model);
    }),
    ...options,
  });
}

export function disabledWhenVariant() {
  return computed('model.cmsVariantParentId', function () {
    return isVariant(this.model);
  });
}

export function disabledWhenVariantOrNotNew() {
  return computed('model.{cmsVariantParentId,isNew}', function () {
    return isVariant(this.model) || !this.model?.isNew;
  });
}

function isVariant(model) {
  const variantParentId = model?.cmsVariantParentId;

  return Boolean(variantParentId) && variantParentId !== '0';
}

export { validator } from 'ember-cp-validations';
